// extracted by mini-css-extract-plugin
export default {"item":"MenuBarItem_item__ViG7X","text":"MenuBarItem_text__N3Hoi","underline":"MenuBarItem_underline__l4Qkj"};